(function () {
    'use strict';
    angular
        .module('app')
        .controller('manualRelationships', manualRelationships);
    manualRelationships.$inject = ['$rootScope', '$scope', 'sidebarservice', 'gridDataService', 'manualRelationshipsService', '$filter', '$timeout', 'loginService', 'ddService'];
    function manualRelationships($rootScope, scope, sidebarservice, gridDataService, manualRelationshipsService, $filter, $timeout, loginService, ddService) {

        // Init.
        scope.accessDeniedLibId = "access_denied";
        scope.loginService = loginService;
        scope.labelString = loginService.resourceStrings["PICK_ITEMS_IN_A_GRID"];
        scope.cantAddString = loginService.resourceStrings["ALREADY_CHILD_OF_DIFF_TYPE"];
        scope.cantRemoveString = loginService.resourceStrings["CANT_REMOVE_CHILD_WITHOUT_ACCESS"];
        scope.sidebarservice = sidebarservice;
        scope.xyz = { lastItem: "", processing: false, labelString: scope.labelString, bRemoveEnabled: false };

        //
        // On selection changed in the grid.
        //
        scope.selectItem = function (item) {
            // Always set all items to not selected.
            angular.forEach(scope.gridOptions.data, function (item) {
                item.isSelected = false;
            });
            // Get the selected items.
            var items = [];
            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (item) {
                item.isSelected = true;
                items.push(item.selectionItem);
            });
            // Do Enables.
            scope.doEnables();
        };

        //Subscribe to the ddService's onResize
        ddService.registerOnResizeCallBack(function () {
            $timeout(function () {
                scope.gridApi.grid.handleWindowResize();
            }, 1000);
        });


        //
        // Enables.
        //
        scope.doEnables = function () {
            // Walk the grid's items.
            var bOneSelected = false;
            var len = scope.gridOptions.data.length;
            for (var i = 0; i < len; i++) {
                // Get this item.
                var gridItem = scope.gridOptions.data[i];
                // See if this row has an assign-to user.
                if (gridItem.isSelected) {
                    bOneSelected = true;
                    break;
                }
            }
            // Handle enabling OK.
            scope.xyz.bRemoveEnabled = bOneSelected;
        }

        // Hook grid selection events.
        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);
        }

        $(window).resize(function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        });

        scope.gridApi = {};
        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Name', field: 'name', width: '20%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '20%', minWidth: '100' },
                { name: 'Status', field: 'status', width: '10%', minWidth: '100' },
                //{ name: 'LibraryId', field: 'libid', width: '10%', minWidth: '100' },
                //{ name: 'FileId', field: 'fileid', width: '10%', minWidth: '100' },
                //{ name: 'MajRev', field: 'majrev', width: '10%', minWidth: '100' },
                //{ name: 'MinRev', field: 'minrev', width: '10%', minWidth: '100' }

            ],
            onRegisterApi: onRegisterApi
        }

        scope.doColumns = function () {
            // dialog config columns
            var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
            var colLibrary = loginService.resourceStrings["SCHEMA_S_LIBNAME"];
            var colStatus = loginService.resourceStrings["SCHEMA_S_STATUS"];
            scope.gridOptions.columnDefs[0].name = colName;
            scope.gridOptions.columnDefs[1].name = colLibrary;
            scope.gridOptions.columnDefs[2].name = colStatus;
        }

        scope.doColumns();

        // Handler for when the main grid's record is selected.
        scope.hookFunc = function (records) {
            // If there is something coming in, ...
            if (records != null && records.length > 0) {
                // If the right side bar is open in manual relationship mode, ...
                if (scope.sidebarservice.rightSideBarOpen && scope.sidebarservice.rightSideBarMode == 1) {
                    // For each thing selected, ...
                    angular.forEach(records, function (record) {

                        // Get base info.
                        var fileid = record["SCHEMA_S_FILEID"];
                        var majrev = record["SCHEMA_S_MAJREV"];
                        var minrev = record["SCHEMA_S_MINREV"];

                        // Skip if it is the parent.
                        if (fileid == scope.sidebarservice.rightSideBarParent.fileId)
                            return;

                        // Check if this parent already has a this doc as a child of a different relationship type.
                        var bExistAsNonManual = false;
                        // Walk all non-manual children.
                        angular.forEach(scope.nonManualChildren, function (item) {
                            // If this item is the proposed child item, ...
                            if (item.fileid == fileid) {
                                // Then yes.
                                bExistAsNonManual = true;
                                // Set a message for the user.
                                scope.xyz.labelString = scope.cantAddString;
                                // Get the control.
                                var elem = document.getElementById("labelStringId");
                                if (elem != null) {
                                    // Change the background to get the user's attention.
                                    elem.style.backgroundColor = "red";
                                    elem.style.color = "white";
                                    // Set a timeout to restore the control.
                                    $timeout(function () {
                                        // Get the control.
                                        var elem = document.getElementById("labelStringId");
                                        if (elem != null) {
                                            // Put back to a default setting.
                                            elem.style.backgroundColor = "#eee";
                                            elem.style.color = "black";
                                        }
                                        // Put back the original prompt.
                                        scope.xyz.labelString = scope.labelString;
                                    }, 6000)
                                }
                            }
                        });

                        // If we did not find an existing non-manual link between the parent and the child, ...
                        if (!bExistAsNonManual) {
                            // Check if it is already in the grid.
                            var bFound = false;
                            angular.forEach(scope.gridOptions.data, function (item) {
                                // See if the grid item is the same as the proposed child.
                                if (item.fileid == fileid) {
                                    // Update the fileid to this majrev and minrev.
                                    bFound = true;
                                    item.majrev = majrev;
                                    item.minrev = minrev;
                                }
                            });
                            // Else it was not found in the grid, so add it.
                            if (!bFound) {
                                scope.gridOptions.data.push({
                                    name: record["SCHEMA_S_LONGNAME"],
                                    library: record["SCHEMA_S_LIBNAME"],
                                    status: record["SCHEMA_S_STATUS"],
                                    libid: record["SCHEMA_S_LIBID"],
                                    fileid: record["SCHEMA_S_FILEID"],
                                    majrev: record["SCHEMA_S_MAJREV"],
                                    minrev: record["SCHEMA_S_MINREV"]
                                });
                            }
                        }

                    });
                    // Sort.
                    scope.gridOptions.data = $filter('orderBy')(scope.gridOptions.data, 'name', false);
                }
            }
        };

        // Hook the record selected event.
        gridDataService.onRecordSelected(scope.hookFunc);

        scope.onRemove = function () {

            var bSomethingWasAccessDenied = false;

            // Get the selected items.
            var items = [];
            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (item, index) {
                if (item.libid != scope.accessDeniedLibId) {
                    // Index is of selection, so need to get last index of the data.
                    scope.gridOptions.data.splice(scope.gridOptions.data.lastIndexOf(item), 1);
                }
                else {
                    bSomethingWasAccessDenied = true;
                }
            });

            if (bSomethingWasAccessDenied) {
                // Set a message for the user.
                scope.xyz.labelString = scope.cantRemoveString;
                // Get the control.
                var elem = document.getElementById("labelStringId");
                if (elem != null) {
                    // Change the background to get the user's attention.
                    elem.style.backgroundColor = "red";
                    elem.style.color = "white";
                    // Set a timeout to restore the control.
                    $timeout(function () {
                        // Get the control.
                        var elem = document.getElementById("labelStringId");
                        if (elem != null) {
                            // Put back to a default setting.
                            elem.style.backgroundColor = "#eee";
                            elem.style.color = "black";
                        }
                        // Put back the original prompt.
                        scope.xyz.labelString = scope.labelString;
                    }, 6000)
                }
            }

            scope.doEnables();
        }

        // After Unsubscribe, refresh main grid and DD.
        scope.updateMainGrid = function () {
            // Someday, parent and child flags will need to be updated.
            var items = [];
            var selectionItem = {
                tableNumber: sidebarservice.rightSideBarParent.tableNumber,
                fileId: sidebarservice.rightSideBarParent.fileId,
                majRev: sidebarservice.rightSideBarParent.majRev,
                minRev: sidebarservice.rightSideBarParent.minRev,
            };
            // Add to the main list.
            items.push(selectionItem);
            var slx = { mode: 0, order: 0, list: items };
            gridDataService.updateGridRecords(slx.list);

            // Then update the DD too.
            gridDataService.recordSelected(gridDataService.selectedRows);
        }

        scope.onManualRelationshipsOK = function () {
            var xRefNodeModelList = [];
            angular.forEach(scope.gridOptions.data, function (item) {
                if (item.libid != scope.accessDeniedLibId) {
                    xRefNodeModelList.push({
                        childId: item.fileid, childMajRev: item.majrev, childMinRev: item.minrev
                    });
                }
            });
            manualRelationshipsService.setManualRelationships(scope.pTableNumber, scope.pFileId, scope.pMajRev, scope.pMinRev, xRefNodeModelList).then(function (data) {
                if (data != null && data.childrenWithErrors != null && data.childrenWithErrors.length > 0) {
                    // Put up an error message without close the side bar.
                    // Add the first 5 error items.
                    var title = loginService.resourceStrings["MANUAL_RELATIONSHIPS_ERROR"]; // "Manual Relationships Error";
                    var message = "";
                    var count = 0;
                    angular.forEach(data.childrenWithErrors, function (item) {
                        // No break during a forEach, so use if to stop appending..
                        if (count <= 4) {
                            message = message.concat(item.errorMessage).concat('\r\n');
                            count = count + 1;
                        }
                    });
                    // If there are more errors that we are not showing, append "more".
                    if (data.childrenWithErrors.length > count) {
                        var more = loginService.resourceStrings["MANUAL_RELATIONSHIPS_ERROR"]; // "more...";
                        message = message.concat(more);
                    }
                    $rootScope.msgBoxShow(message, title, 0, true);
                }
                else {
                    // Close the side bar.
                    scope.sidebarservice.rightSideBarOpen = false;
                    // Unhook the record selected event.
                    gridDataService.onRecordSelectedUnsubscribe(scope.hookFunc);

                    // After Unsubscribe, refresh main grid and DD.
                    scope.updateMainGrid();
                }
            }, function (response) {
                // Put up an error message without close the side bar.
                var title = loginService.resourceStrings["MANUAL_RELATIONSHIPS_ERROR"]; // "Manual Relationships Error";
                var message = response.statusText;
                if (response.status == 500) {
                    message = message.concat(": ").concat(response.data.Message);
                }
                $rootScope.msgBoxShow(message, title);
            });
        }
        scope.onManualRelationshipsCancel = function () {
            // Close the side bar.
            scope.sidebarservice.rightSideBarOpen = false;
            // Unhook the record selected event.
            gridDataService.onRecordSelectedUnsubscribe(scope.hookFunc);
        }

        // Save the parent info.
        scope.pTableNumber = sidebarservice.rightSideBarParent.tableNumber;
        scope.pFileId = sidebarservice.rightSideBarParent.fileId;
        scope.pMajRev = sidebarservice.rightSideBarParent.majRev;
        scope.pMinRev = sidebarservice.rightSideBarParent.minRev;

        // Get all children. Put non-manual in a list. Put manual in the grid.
        manualRelationshipsService.getChildren(scope.pTableNumber, scope.pFileId, scope.pMajRev, scope.pMinRev).then(function (xRefReturnPacketModel) {
            scope.nonManualChildren = [];
            var MANUAL_LINKAGE = "GP";
            var XRITEM_UNAVAILABLE = 85; // 'U';
            // If we got back a valid return, ...
            if (xRefReturnPacketModel != null && xRefReturnPacketModel.xRefTopLevelNode != null) {
                // Walk the direct children, ...
                angular.forEach(xRefReturnPacketModel.xRefTopLevelNode.childNodeList, function (xRefNodeModel) {
                    // Get basic info.
                    var fileId = xRefNodeModel.childId;
                    var majRev = xRefNodeModel.childMajRev;
                    var minRev = xRefNodeModel.childMinRev;
                    // If manual, ...
                    if (xRefNodeModel.relType == MANUAL_LINKAGE) {
                        // Can't have an unresolved manual relationship anyway.
                        //TD 07-25-2017 Removed fileRecordItemPointer from XrefNodeModel.
                        //              Use XrefNodeModel.childId as the key into the return packet's fileitems.
                        //if (xRefNodeModel.fileRecordItemPointer != null) {
                        if (xRefNodeModel.stateChild != XRITEM_UNAVAILABLE) {
                            // Get the resolved document info.
                            //var xRefFileRecordModel = xRefReturnPacketModel.fileItems[xRefNodeModel.fileRecordItemPointer.FileRecordItemPointer];
                            var xRefFileRecordModel = xRefReturnPacketModel.fileItems[xRefNodeModel.childId];
                            if (xRefFileRecordModel != null) {
                                var longname = xRefFileRecordModel.longName;
                                var library = xRefFileRecordModel.libraryName;
                                var status = xRefFileRecordModel.status;
                                var libId = xRefFileRecordModel.libraryId;
                                // Add manual to the grid. 
                                scope.gridOptions.data.push({
                                    name: longname,
                                    library: library,
                                    status: status,
                                    libid: libId,
                                    fileid: fileId,
                                    majrev: majRev,
                                    minrev: minRev
                                });
                            }
                        }
                        else {
                            scope.gridOptions.data.push({
                                name: loginService.resourceStrings["ACCESS_DENIED"],
                                library: loginService.resourceStrings["ACCESS_DENIED"],
                                status: loginService.resourceStrings["ACCESS_DENIED"],
                                libid: scope.accessDeniedLibId,
                                fileid: fileId,
                                majrev: majRev,
                                minrev: minRev
                            });
                        }
                    }
                    else { // Else non-manual, ...
                        // Save non-manual to block the same document from being added as a manual.
                        scope.nonManualChildren.push({
                            name: "", // not necessary because not in UI
                            library: "", // not necessary because not in UI
                            status: "", // not necessary because not in UI
                            libid: "", // not necessary because not in UI
                            fileid: fileId,
                            majrev: majRev,
                            minrev: minRev
                        });
                    }
                });
                // Sort.
                scope.gridOptions.data = $filter('orderBy')(scope.gridOptions.data, 'name', false);
            }
        }, function (response) {
            // Put up an error message without close the side bar.
            var title = loginService.resourceStrings["MANUAL_RELATIONSHIPS_ERROR"]; // "Manual Relationships Error";
            var message = response.statusText;
            if (response.status == 500) {
                message = message.concat(": ").concat(response.data.Message);
            }
            $rootScope.msgBoxShow(message, title);
        });

        $(window).on('resize', function () {
            $timeout(function () {
                scope.gridApi.grid.handleWindowResize();
            }, 1000);
            
        });

        activate();

        function activate() { }
    }
})();
